<template>
	<div class="Pedido">
		<h6>Pedido</h6>

		<b-container>
			<Cantidad
				:tipo="tipo"
				:colores.sync="setcolores"
				@AddCantidades="AddCantidades($event)"
			></Cantidad>
			<div class="d-flex flex-row bd-highlight mb-3">
				<div class="p-2 bd-highlight">
					<span style="font-size:14px">Ubicacion:</span>
				</div>
				<div class="p-2 bd-highlight">
					<b-form-radio-group
						:options="options"
						v-model="pedido.ubicacion"
						v-model.lazy="pedido.ubicacion"
						size="sm"
						style="font-size:12px"
					></b-form-radio-group>
				</div>
			</div>
			<b-form @submit="onSubmit">
				<cite>Datos de contacto</cite>
				<hr/>
				<b-form-group
					label-cols-sm="5"
					style="font-size:14px"
					label="Mail:"
					label-align-sm="right"
					label-for="Mail"
				>
					<b-form-input
						v-model="pedido.mail"
						size="sm"
						id="Mail"
						:state="Mailvalidation"
					></b-form-input>
					<b-form-invalid-feedback :state="Mailvalidation">
						{{ this.MensajeMail }}
					</b-form-invalid-feedback>
					<b-form-valid-feedback :state="Mailvalidation"></b-form-valid-feedback>
				</b-form-group>
				<b-form-group
					label-cols-sm="5"
					style="font-size:14px"
					label="Nombre / Codigo Mercado Libre:"
					label-align-sm="right"
					label-for="Nombre"
				>
					<b-form-input
						id="Nombre"
						v-model="pedido.nombre"
						size="sm"
						:state="Nombrevalidation"
					></b-form-input>
					<b-form-invalid-feedback :state="Nombrevalidation">
						Debe completar este campo.
					</b-form-invalid-feedback>
					<b-form-valid-feedback :state="Nombrevalidation"></b-form-valid-feedback>
				</b-form-group>
				<b-form-group
					label-cols-sm="5"
					style="font-size:14px"
					label="Telefono:"
					label-align-sm="right"
					label-for="Telefono"
					input-col-sm="3"
				>
					<b-form-input
						size="sm"
						v-model="pedido.telefono"
						id="Telefono"
						:state="Telefonovalidation"
					></b-form-input>
					<b-form-invalid-feedback :state="Telefonovalidation">
						Debe ingresar un n�mero de telefono de contacto
					</b-form-invalid-feedback>
					<b-form-valid-feedback :state="Telefonovalidation"></b-form-valid-feedback>
				</b-form-group>

				<b-form-group
					label-cols-sm="5"
					style="font-size:14px"
					label="Precio:"
					label-align-sm="right"
					label-for="Precio"
				>
					<b-form-input
						size="sm"
						id="Precio"
						v-model="precio"
						:state="Preciovalidation"
						readonly
					></b-form-input>
					<b-form-invalid-feedback :state="Preciovalidation">
						Debe seleccionar la cantidad solicitada.
					</b-form-invalid-feedback>
					<b-form-valid-feedback :state="Preciovalidation"></b-form-valid-feedback>
				</b-form-group>

				<b-form-group
					label-cols-sm="5"
					style="font-size:14px"
					label=""
					label-align-sm="right"
				>
					<b-button pill block variant="outline-dark" type="submit">Enviar</b-button>
				</b-form-group>
			</b-form>
		</b-container>
	</div>
</template>

<script>
	import axios from 'axios'
	import Cantidad from './Cantidad.vue'
	export default {
		name: 'Pedido',
		props: {
			tipo: String,
			pulsera: String,
			colores: Array,
			precios: Array,
		},

		watch: {
			colores() {
				this.$emit('update:colores', this.colores)
				return this.colores
			},
			precios() {
				this.$emit('update:precios', this.precios)
				return this.precios
			},
		},
		components: {
			Cantidad,
		},

		data: function() {
			return {
				selected: 'first',
				mensaje: '',
				pedido: {
					ubicacion: 1,
					mail: '',
					nombre: '',
					telefono: '',
					cantidades: [],
					precioTotal: 0,
					txtUbicacion: '',
				},
				validar: false,
				options: [
					{ text: 'CABA/GBA', value: 1 },
					{ text: 'Interior del pais', value: 1.21 },
				],
			}
		},

		computed: {
			MensajeMail: {
				get: function() {
					return this.mensaje
				},
				set: function(valor) {
					this.mensaje = valor
				},
			},
			valida: {
				get: function() {
					return this.validar
				},
				set: function(valor) {
					this.validar = valor
				},
			},
			Preciovalidation() {
				if (!this.valida) {
					return null
				}

				return this.precio > 0
			},
			Telefonovalidation() {
				if (!this.valida) {
					return null
				}

				return this.pedido.telefono.length > 0
			},
			Mailvalidation() {
				if (!this.valida) {
					return null
				}
				let emailRegex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
				if (this.pedido.mail.length > 0) {
					if (emailRegex.test(this.pedido.mail)) {
						return true
					} else {
						this.mensaje = 'La direcci�n de email es incorrecta.'
						return false
					}
				} else {
					this.mensaje = 'Debe completar este campo.'
					return false
				}
			},
			Nombrevalidation() {
				if (!this.valida) {
					return null
				}
				return this.pedido.nombre.length > 0
			},
			precio: function() {
				return this.calcularPrecio() * this.pedido.ubicacion
			},

			selectPulsera: {
				// getter
				get: function() {
					return this.pulsera
				},
			},
			setcolores: {
				get: function() {
					return this.colores
				},
				set: function(colores) {
					this.colores = colores
				},
			},
			setprecios: {
				get: function() {
					return this.precios
				},
				set: function(precios) {
					this.precios = precios
				},
			},
		},

		methods: {
			onSubmit(evt) {
				evt.preventDefault()
				this.valida = true
				let valor =
					this.Telefonovalidation == true &&
					this.Telefonovalidation == this.Preciovalidation &&
					this.Preciovalidation == this.Mailvalidation &&
					this.Mailvalidation == this.Nombrevalidation
				if (valor) {
					let aux = this.options.filter((x) => x.value == this.pedido.ubicacion)

					this.pedido.txtUbicacion = aux[0].text
					this.pedido.precioTotal = $('#Precio').val()
					console.log(this.pedido)
					this.$emit('AddPedido', this.pedido)
				}
			},

			AddCantidades(v_cantidades) {
				this.pedido.cantidades = v_cantidades
			},
			TotalCantidad() {
				var total = 0
				for (var prop in this.pedido.cantidades) {
					total += parseInt(this.pedido.cantidades[prop].cantidad)
				}
				return total
			},

			calcularPrecio() {
				var cantidad = this.TotalCantidad()

				let precio = 0

				if (cantidad <= 0) {
					precio = 0
				}
				if (cantidad > 0 && cantidad <= 100) {
					precio = this.setprecios[0]
				}
				if (cantidad > 100 && cantidad <= 150) {
					precio = this.setprecios[1]
				}
				if (cantidad > 150 && cantidad <= 200) {
					precio = this.setprecios[2]
				}
				if (cantidad > 200 && cantidad <= 250) {
					precio = this.setprecios[3]
				}
				if (cantidad > 250 && cantidad <= 300) {
					precio = this.setprecios[4]
				}
				if (cantidad > 300 && cantidad <= 350) {
					precio = this.setprecios[5]
				}
				if (cantidad > 350 && cantidad <= 400) {
					precio = this.setprecios[6]
				}
				if (cantidad > 400 && cantidad <= 500) {
					precio = this.setprecios[7]
				}
				if (cantidad > 500 && cantidad <= 600) {
					precio = this.setprecios[8]
				}
				if (cantidad > 600 && cantidad <= 700) {
					precio = this.setprecios[9]
				}
				if (cantidad > 700 && cantidad <= 800) {
					precio = this.setprecios[10]
				}
				if (cantidad > 800 && cantidad <= 900) {
					precio = this.setprecios[11]
				}
				if (cantidad > 900 && cantidad <= 1000) {
					precio = this.setprecios[12]
				}
				if (cantidad > 1000 && cantidad < 5000) {
					precio = cantidad * this.setprecios[13]
				}
				if (cantidad >= 5000 && cantidad < 10000) {
					precio = cantidad * this.setprecios[14]
				}
				if (cantidad >= 10000 && cantidad < 15000) {
					precio = cantidad * this.setprecios[15]
				}
				if (cantidad >= 15000 && cantidad < 20000) {
					precio = cantidad * this.setprecios[16]
				}
				if (cantidad >= 20000 && cantidad < 50000) {
					precio = cantidad * this.setprecios[17]
				}
				if (cantidad >= 50000) {
					precio = cantidad * this.setprecios[18]
				}
				return precio
			},
		},
	}
</script>

<style scoped></style>
